import { Injectable } from '@angular/core';
import {  Http, Response, Headers} from '@angular/http';
import { Observable ,pipe} from 'rxjs';
import { map } from 'rxjs/operators';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
/*
Generat    createuserPetDetail(): any {
        throw new Error("Method not implemented.");
    }
ed class for the DoctorserviceProvider provider.

See https://angular.io/docs/ts/latest/guide/dependency-injection.html
for more info on providers and Angular DI.
*/

@Injectable()
export class AdoptionService {
    private cdtk= "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjZlOWVlZDVjODQ5Yzk1YTVlNjIwYTUyMDMwMTYyMDJiOTBmYzAxNzRkMzA3NDc0OTc1ZmFlMDgyNDdkMGNhNjdiNmFhMzIzM2NmMjgyYjA0In0.eyJhdWQiOiIzIiwianRpIjoiNmU5ZWVkNWM4NDljOTVhNWU2MjBhNTIwMzAxNjIwMmI5MGZjMDE3NGQzMDc0NzQ5NzVmYWUwODI0N2QwY2E2N2I2YWEzMjMzY2YyODJiMDQiLCJpYXQiOjE1MzE0MDA3MjcsIm5iZiI6MTUzMTQwMDcyNywiZXhwIjoxNTYyOTM2NzI3LCJzdWIiOiIiLCJzY29wZXMiOltdfQ.dz0LSq7-jtxzrLmH6KgrNFGBYYq7UHf9n10owKt1JSoUdoLiCJJEmTprHufPiBrzu_6FxwivAUW5gD6yCQicAeVvxqBk1V3lNJduKt8TrCqeJWhqlECRvPp-fRJsbh3ZxsPwysKrAlb2AeWBv_NowO7nRyB4IpUiTatmV_Ud41WdM_pW-hBdJGLlX8-m5wHRYGOyMQay257byTtqOtJHVpouZd8b3Itta2uVX4cVaGgtTosebKfuLYG_xs5yLGMXXuab8pL2e5IdhYsYe1WJ0n-1qUK0ZH26WyLBZzEQ7s7DR3HGJN_YfBRLEDRmphvnYxBeAfiKtl1G4ztFSOksG5Qwxq-YugCODot_AmiNvUVxqRumgzegyx-xJN-Xc7ATbghFQ9iJwpLRiiqbQrFtsAe8eB6dLMpQ-mV4wFqZp51EQtAViW0LL9Rb9z1pghaMhBdurNyKCr5r-dMgI8fPAUd5iEQ8lloz-BJ_dowSiotHiPMNgpQOuQ_3lMKZyWs9UGxyCzCJ5g52Pe28Qvd8KLZ5uyI6pOQZNBRHGD0QRjn9erW3tDGDWx-Teba77YiLlpGjpX9zxbruEun0n3BlorGX7QEncW9riLorDC8OnWPNvgL1Iu1d1sEYYFKdfJETfrBCcrDWjexHWtbBtZZEthztq1wPiqbtOw5INiTjV6Q";
    clientcredentialheader = new Headers({'Content-Type':'application/json',
    'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest',
    'Authorization': this.getClientCredential()});
     authcredheader: any;
constructor(public http: Http,@Inject(PLATFORM_ID) private platformId: Object) {

}
getClientCredential(){
    var Bearer= 'Bearer' + ' ' + this.cdtk;
    return Bearer;
  }
  getAuthCredential(){
    if (isPlatformBrowser(this.platformId)) {
    var a = localStorage.getItem("token");
    var tjson =JSON.parse(a);
    if(tjson != null){
      var auth= 'Bearer' + ' ' +  tjson.token;
      return auth;
    }   
   }
  }
  genAuthHeader(){
    this.authcredheader = new Headers({'Content-Type':'application/json',
    'Accept':'application/json', 
    'Authorization': this.getAuthCredential()})
  }

getMyAdoptionList(uid) {
 return this.http.get('https://passport.petcart.in/adoption?user_id=' + uid ,
 {headers: this.clientcredentialheader})
 .pipe(map((response: Response) => {
     return response.json().data;
 })
);
}
getMyAdoptionPendingList(uid) {
    return this.http.get('https://passport.petcart.in/adoption?user_id=' + uid ,
    {headers: this.clientcredentialheader})
    .pipe(map((response: Response) => {
        return response.json().data;
    })
    );
   }
getBreeds(): Observable<any> {
    return this.http.get('https://passport.petcart.in/breeds',
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
}
getLocation(lid) {
    return this.http.get('https://passport.petcart.in/location?parent_location_id=' + lid,
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
}
getAllLocation() {
    return this.http.get('https://passport.petcart.in/location',
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
}
getAdoptionCity() {
    return this.http.get('https://passport.petcart.in/location?parent_location_id=' + 0,
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
}
createAdoptionPost(user_id, petname, adopstat, btype, gender, location, age, color, filename,
     pettype, city, desc, q1, q2, q3) {
         this.genAuthHeader();
    return this.http.post('https://passport.petcart.in/adoption',
    {user_id: user_id, pet_name: petname, photo: filename, gender: gender, location_id: location,
    breed_id: btype, age: age, color: color, adoptionstatus: adopstat, pet_type: pettype,
    city_id: city, description: desc, neutered: q1, vaccination: q2, kci: q3, showcontact: 'show'},
    {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
    );
  }
  updateAdoptiondata(id, status) {
      this.genAuthHeader();
    return this.http.put('https://passport.petcart.in/adoption/' + id,
    {adoptionstatus: status }, {headers: this.authcredheader})
    .pipe(map( (response: Response) => {
        return response.json().data;
    })
   ) ;
  }
  getParticulerBreed(pid) {
    return this.http.get('https://passport.petcart.in/breeds?parent_id=' + pid,
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
  }
  getAdoptionpost(pettype) {
    return this.http.get('https://passport.petcart.in/adoption?pet+type=' + pettype + '&adoptionstatus=' + 'published',
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
  }
  getPostDetail(post_id){
    return this.http.get('https://passport.petcart.in/adoption/' + post_id,
    {headers: this.clientcredentialheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
    );
  }
  getPostContact(uid){
      this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/users/' + uid,
    {headers: this.authcredheader})
.pipe(map(
    (response: Response) => {
    return response.json().data;
    })
);
  }
  postContactRequest(fid, pid, user_id) {
      this.genAuthHeader();
    return this.http.post('https://passport.petcart.in/adoptionrequest',
    {adoptionpost_id: pid, contacteduser_id: user_id, adoptionform_id: fid, status: 'requested' , sharecontact: 'pending'},
    {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
    );
  }
  setAdoptionDocumentPath(id, doctype, filename) {
      this.genAuthHeader();
    return this.http.post('https://passport.petcart.in/adoptiondocs',
    {adoption_id: id, document_type: doctype, path: filename},
    {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
    );
  }
  getDocumentForParticularAdoption(post_id) {
    return this.http.get('https://passport.petcart.in/adoptiondocs?adoption_id=' + post_id,
    {headers: this.clientcredentialheader})
    .pipe(map(
        (response: Response) => {
            return response.json().data;
        })
    );
 }
 changeAdoptionStatus(id) {
     this.genAuthHeader();
    return this.http.put('https://passport.petcart.in/adoption/' + id,
    {adoptionstatus: 'adopted' }, {headers: this.authcredheader})
    .pipe(map( (response: Response) => {
        return response.json().data;
    })
);
  }
  getAllState() {
    return this.http.get('https://passport.petcart.in/states',
    {headers: this.clientcredentialheader})
    .pipe(map((response: Response) => {
        return response.json().data;
    })
);
  }
    SendAdoptionPostRequestForm(state, city , pin, prof, btf, q1, q2, q3, q4, q5, q6, q7, q8, q9, q10, q11,
     q12, q13 , q14, q15, dob) {
         this.genAuthHeader();
    return this.http.post('https://passport.petcart.in/adoptionform',
  {timetocall: btf, state_id: state, city_id: city, pin: pin, profession: prof, allagree: q1, caretaker: q2,
   housetype: q3, isrented: q4, restriction: q8, peoplecount: q5, kidscount: q6, pethome: q7,
  prevpet: q9, prevpetdetails: q10 , currentpet: q11, currentpetdetails: q12, availtime: q13, expenses: q14,
  housecheck: q15, dob: dob },
  {headers: this.authcredheader})
  .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
    );
   }
   alreadySentRequestForAdoption(pid, uid) {
       this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/adoptionrequest?adoptionpost_id=' + pid + '&contacteduser_id=' + uid,
    {headers: this.authcredheader})
   .pipe(map(
      (response: Response) => {
       return response.json().data;
      })
    );
   }
   getRequestForPerticularPost(post_id) {
       this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/adoptionrequest?adoptionpost_id=' + post_id ,
    {headers: this.authcredheader})
   .pipe(map(
      (response: Response) => {
       return response.json().data;
      })
    );
   }
   getAdoptionrequestDetail(rid) {
       this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/adoptionrequest/' + rid ,
    {headers: this.authcredheader})
   .pipe(map(
      (response: Response) => {
       return response.json().data;
      })
    );
   }
   getAdoptionFormDetail(fid) {
    this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/adoptionform/' + fid ,
    {headers: this.authcredheader})
   .pipe(map(
      (response: Response) => {
       return response.json().data;
      })
    );
   }
   rejectForm(id) {
       status = 'rejected';
       this.genAuthHeader();
    return this.http.put('https://passport.petcart.in/adoptionrequest/' + id,
    {status: status},
    {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
     )  ;
   }
   shortlistForm(id, contacttype) {
       this.genAuthHeader();
    return this.http.put('https://passport.petcart.in/adoptionrequest/' + id,
    {status: 'shortlisted',  sharecontact: contacttype },
    {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
    );
   }
   getAdoptionFormForUser(userid) {
       this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/adoptionrequest?contacteduser_id=' + userid + '&sort_bydesc=created_at',
    {headers: this.authcredheader})
    .pipe(map(
        (response: Response) =>  {
            return response.json().data;
        })
    );
   }
   getLastAdoptionform(formid) {
       this.genAuthHeader();
    return this.http.get('https://passport.petcart.in/adoptionform/' + formid,
    {headers: this.authcredheader})
    .pipe(map(
        (response: Response) =>  {
            return response.json().data;
        })
    );
   }
}
